<div mat-dialog-title [innerHTML]="data.title | translate"></div>
<div mat-dialog-content style="padding-bottom: 2rem;" [innerHTML]="data.message | translate"></div>
<div mat-dialog-actions [align]="data.action_align">
    <button mat-stroked-button mat-dialog-close color="{{ data.close_btn_color }}" class="mr-1">{{ data.close_btn_text | translate }}</button>
    <button mat-stroked-button [mat-dialog-close]="true" color="{{ data.confirm_btn_color }}">{{ data.confirm_btn_text | translate }}</button>
</div>